<template>
  <div class="home">


    <!-- <p>{{location.iss_position}}</p> -->

    <div class="homeContainer">

      <div class="imgNum">
        <div class="numbers_1">
          <transition name="sideNumbers" mode="out-in" appear>
            <p v-if="toAnimateISS" class="up chromatic">{{longitude}}</p>
          </transition>

          <transition name="sideNumbers" mode="out-in">
            <p v-if="toAnimatePeople" class="up chromatic">{{people}} </p>
          </transition>

          <transition name="sideNumbers" mode="out-in">
            <p v-if="toAnimateISS" class="down chromatic">{{latitude}}</p>
          </transition>
        </div>


        <div class="homeImage">
            <transition name="sideImage">
              <img v-if="toAnimate" src="../assets/Home_2.gif">
            </transition>
        </div>
    </div>

      <div class="infoContainer">

        
      <!-- <div class="buttonConatiner" v-if="toAnimate"> -->
      <transition name="sideInfo" mode="out-in">
        <div v-if="toAnimate" class="cheating">
          <p>
            <input type="text" name="cheat" v-on:keyup="timer()" v-model="cheat"/>
          </p>
        </div>
      </transition>
      <!-- </div> -->

      <transition name="sideInfo" mode="out-in">
        <div class="aboutMe" v-if="toAnimate">
          <p v-for="line in main_info" :key="line">{{line}}</p>
          <p v-for="extra_line in extra" class="extraInfo" :key="extra_line">{{extra_line}}</p>
        </div>
      </transition>

      <transition name="sideInfo" mode="out-in">
        <div v-if="toAnimate" class="cheatingDown">
          <span> </span>
        </div>
      </transition>


      <div class="buttonConatiner">
        <transition name="sideInfo"  mode="out-in">
        <div v-if="toAnimate" class="socialMedia">
          <button class="myCV" @click="opentab('cv')">download_CV</button>
          <button class="insta" @click="opentab('instagram')">INSTAGRAM</button>
          <button class="linkedin" @click="opentab('linkedin')">LINKEDIN</button>
          <!-- <p>
            /<input type="text" name="cheat" v-on:keyup="timer()" v-model="cheat"/>
          </p> -->
        </div>
        </transition>
      </div>

      </div>

    </div>


  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {store} from "../store.js";
import axios from "axios";

export default {
  name: 'home',
  data(){
    return{
      Heading:"ME",
      location:null,
      longitude:"",
      latitude:"",
      people:null,
      main_info:[
        "bhargav modha.",
        "oct '99.",
        "--------------------",
        "associate designer @ rockstar games",
        "-",
        "i made this online/interactive CV website to showcase my",
        "• experience & extra ACTIVITIES",
        "• uni & personal PROJECTS",
        "• EDUCATION",
        // "along with backstories for most of them"
        // "updated"
      ],
      extra:["i would recommend to view this site on a bigger display to get the full experience"],
      toAnimate:false,
      toAnimateISS:false,
      toAnimatePeople:false,
      cheat:null,
      // url:'http://localhost/For_Site/CV/BhargavModha_CV.pdf',
      url:'./CV/BhargavModha_CV.pdf',
      mytimer:null
    }
  },
  methods:{
    // ISS LOCATION API
    getLocation: function(){
      axios.get('http://api.open-notify.org/iss-now.json')
      .then((response)=>{
        if(response.data.message=="success"){
          this.longitude = response.data.iss_position.longitude;
          this.latitude = response.data.iss_position.latitude;
          this.toAnimateISS=true;
        }
      })
    },
    getPeople: function(){
      axios.get('http://api.open-notify.org/astros.json')
      .then((response)=>{
        if(response.data.message=="success"){
          this.people=response.data.number;
          this.toAnimatePeople=true;
        }
      })
    },
    opentab(type){
      // console.log(type);
      switch(type){
        case "instagram":
          window.open("http://instagram.com/bhargavmodha/", "_blank");
          break;
        case "linkedin":
          window.open("http://www.linkedin.com/in/bhargavmodha","_blank");
          break;
        case "cv":
          this.downloadWithAxios();
          break;
      }
    },
    resetVariable(){
      clearInterval(this.interval)

      this.longitude=null;
      this.latitude=null;
      this.people=null;

      this.toAnimate=false;
      this.toAnimateISS=false;
      this.toAnimatePeople=false;
    },
    getCheat(){
        switch(this.cheat){
          case "admin" :
            this.$router.push("/admin");
            break;
          case "interstellar" :
            this.$router.push("/space");
            break;
          case "gwent" :
            this.$router.push("/card_game");
            break;
          default :
            this.cheat=null;
            break;
        }
    },
    timer(){
        clearTimeout( this.mytimer );
        this.mytimer = setTimeout(() => { this.getCheat() }, 3000);
    },
    
    forceFileDownload(response){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'BhargavModha_CV.pdf') //or any other extension
      document.body.appendChild(link)
      link.click()
    },

    downloadWithAxios(){
      axios({
        method: 'get',
        url: this.url,
        responseType: 'arraybuffer'
      })
      .then(response => {
        
        this.forceFileDownload(response)
        
      })
      .catch(() => console.log('error occured'))
    }


  },created() {
    store.clearSubPath();
    if (location.protocol === 'http:') {
      this.getPeople();
      this.interval = setInterval(() => this.getLocation(), 1000);
    }
    this.$nextTick(function () {this.toAnimate=true; })
  },
  watch: {
    $route(to, from) {
      store.clearSubPath();
    }
  },
  beforeRouteLeave(to, from, next){
    // console.log(this.info);
    this.resetVariable();
    setTimeout(() => { next() }, 1000)
  }
}
</script>

<style scoped>
.homeContainer {
  margin-top:3em;
  display: -ms-grid;
  display: grid;
  grid-gap: 0.5em;
  -ms-grid-columns: 2fr 0.5em 3fr;
  grid-template-columns: 2fr 3fr;
  text-align: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-grid-row-align: center;
      align-self: center;
}


.numbers_1{
-ms-grid-column: 1;
grid-column: 1;
text-align: center;
  display: -ms-grid;
  display: grid;
  min-width: 55px;;
  -ms-grid-columns: 1fr;;
  grid-template-columns: 1fr;
  overflow: hidden;
}

.numbers_1 .up,.numbers_1 .down{
  -ms-flex-item-align: center;
      -ms-grid-row-align: center;
      align-self: center;
  opacity: 0.5;
  -webkit-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  transform: rotate(-90deg);
  
}


.numbers_1 p{
  font-family: 'Courier New', Courier, monospace;
  font-size: 10px;
}

.infoContainer{
  -ms-flex-item-align: center;
      -ms-grid-row-align: center;
      align-self: center;
  overflow: hidden;
}

.aboutMe{
-ms-flex-item-align: center;
    -ms-grid-row-align: center;
    align-self: center;
border-left:1px solid white;
}

.aboutMe p{
  font-family: 'Courier New', Courier, monospace;
  font-size: 15px;
  line-height: 22px;
  margin: 0px 0px 0px 15px;
  text-align: left;
}



.homeImage{
-ms-grid-column: 2;
grid-column: 2;
overflow: hidden;
min-width: 275px;
}

.homeImage img{
-ms-grid-column: 2;
grid-column: 2;
max-width: 275px;

}

.homeBody{
  margin-top: 2em;
}

.homeBody p {
font-family: 'Courier New', Courier, monospace;
margin: 3px;
font-size: 15px;
}


.socialMedia{
  margin-top: 4em;
  display:-ms-grid;
  display:grid;
  grid-gap: 10px;
  -ms-grid-columns: 1fr;
  grid-template-columns: 1fr;
  text-align: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;

}

.socialMedia button{
  -ms-flex-item-align: center;
      -ms-grid-row-align: center;
      align-self: center;
  text-align: left;
  max-width: 25%;
  height: 1.7em;
  font-family: 'Courier New', Courier, monospace;
  -webkit-transition: 0.4s ease;
  -o-transition: 0.4s ease;
  transition: 0.4s ease;
}

.socialMedia button:hover{
  max-width: 75%;
}

.socialMedia .insta:hover{
  color: white;
  background: -webkit-gradient(linear, left top, right top, from(#dd2a7b), color-stop(#8134af), to(#515bd4));
  background: -o-linear-gradient(left, #dd2a7b, #8134af, #515bd4);
  background: linear-gradient(90deg, #dd2a7b, #8134af, #515bd4);
}

.socialMedia .linkedin:hover{
  color: white;
  background:#0e76a8;
}

.socialMedia .myCV:hover{
  background: white;
  color: black;
}




.chromatic:hover{
    background-color: transparent;
    color: white;
     -webkit-filter: url(#kill);
     -moz-filter: url(#kill);
  -o-filter: url(#kill);
  -ms-filter: url(#kill);
  filter: url(#kill);
}

.buttonConatiner{
overflow: hidden;

}


.cheating p{
  border-left:1px solid rgb(255, 255, 255,1);
  font-family: 'Courier New', Courier, monospace;
  margin: 0;
  text-align: left;
  padding:1px 6px;
  margin-bottom: 1em;
}

.cheating p input{
  text-align: left;
  background: transparent;
  border:none;
  width: 75%;
  padding:2px 10px;
  font-family: 'Courier New', Courier, monospace;
  -webkit-transition: 0.4s ease;
  -o-transition: 0.4s ease;
  transition: 0.4s ease;
  outline: none;
}

.cheatingDown{
  text-align: left;
  margin-top: 1em;
}

.cheatingDown span{
   padding:1px;
  border-left:1px solid rgb(255, 255, 255,1);
}



.imgNum{
  display: -ms-grid;
  display: grid;
}

  .extraInfo{
    display: none;
  }


/* ANIMATIONS */


.sideNumbers-enter-active{
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  -webkit-transition-delay: 1s;
       -o-transition-delay: 1s;
          transition-delay: 1s;
}
.sideNumbers-leave-active {
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  /* transition-delay: 0.3s; */
}
.sideNumbers-enter {
  opacity: 0;
  -webkit-transform: translateX(100px) rotate(-90deg) !important;
      -ms-transform: translateX(100px) rotate(-90deg) !important;
          transform: translateX(100px) rotate(-90deg) !important;
}
.sideNumbers-leave-to {
  opacity: 0;
  -webkit-transform: translateX(100px) rotate(-90deg) !important;
      -ms-transform: translateX(100px) rotate(-90deg) !important;
          transform: translateX(100px) rotate(-90deg) !important;
}

.sideImage-enter-active{
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.sideImage-leave-active {
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  -webkit-transition-delay: 0.5s;
       -o-transition-delay: 0.5s;
          transition-delay: 0.5s;
}
.sideImage-enter {
  /* opacity: 0; */
  -webkit-transform: translateX(-400px)  !important;
      -ms-transform: translateX(-400px)  !important;
          transform: translateX(-400px)  !important;
}
.sideImage-leave-to {
  opacity: 0;
  -webkit-transform: translateX(-400px);
      -ms-transform: translateX(-400px);
          transform: translateX(-400px);

}

.sideInfo-enter-active{
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  -webkit-transition-delay: 0.6s;
       -o-transition-delay: 0.6s;
          transition-delay: 0.6s;
}
.sideInfo-leave-active {
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  /* transition-delay: 0.3s; */
}
.sideInfo-enter {
  opacity: 0;
  -webkit-transform: translateX(-300px)  !important;
      -ms-transform: translateX(-300px)  !important;
          transform: translateX(-300px)  !important;
}
.sideInfo-leave-to {
  opacity: 0;
  -webkit-transform: translateX(-500px);
      -ms-transform: translateX(-500px);
          transform: translateX(-500px);

}


@media only screen and (max-width: 850px) {
  .homeContainer{
    -ms-grid-columns: 1fr;
    grid-template-columns: 1fr;
    grid-gap: 2em;
    text-align: center;
    -ms-grid-row-align: center;
        align-self: center;
  }
  .imgNum{
    max-width: 330px;
    text-align: center;
    -ms-grid-row-align: center;
        align-self: center;
    display: -ms-inline-grid;
    display: inline-grid;
    margin: 0 auto;
  }

  .socialMedia{
    margin-top: 2em;
  }

  .numbers_1{
    display: none;
  }

  .extraInfo{
    color: lightcoral;
    padding-top: 1em;
    display: inherit;
  }

  .cheatingDown{
    display: none;
  }

}
</style>

